import React, { ReactElement, useContext, useEffect } from "react";
import { UserType } from "../../../graphql/types";
import { UserTypeContext } from "../../../contexts/UserTypeContext";
import { RoutePaths } from "../../../enumStrings";
import FullPageLoader from "../../common/FullPageLoader";
import { useNavigate } from "react-router-dom";
import { useGetLoggedInAppInfo } from "../../../hooks/useGetLoggedInAppInfo";

// User can only access this if logged in so no need to check if logged in here
const Root = (): ReactElement => {
  const navigate = useNavigate();

  const {
    state: { userType },
  } = useContext(UserTypeContext);

  const { firstAllowedPathThatShouldBeConsideredTheHomePageForUser } =
    useGetLoggedInAppInfo();

  useEffect(() => {
    if (userType) {
      if (userType !== UserType.ChamberAdmin) {
        navigate(RoutePaths.login);
      } else {
        navigate(firstAllowedPathThatShouldBeConsideredTheHomePageForUser);
      }
    }
  }, [
    userType,
    navigate,
    firstAllowedPathThatShouldBeConsideredTheHomePageForUser,
  ]);

  return <FullPageLoader />;
};

export default Root;
